import React from 'react';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';
import { stemmer } from 'stemmer';
import { useTheme } from '@mui/material';

interface IHighlightedTextProps {
  text: string;
  searchQuery: string;
  variant: Variant;
}

const HighlightedText = (props: IHighlightedTextProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const { searchQuery, text, variant } = props;

  const getHighlightedText = () => {
    if (!searchQuery) return text;

    // This package exposes a stemming algorithm.
    // That means it gets a certain string, and turns it into a shorter version.
    // E.g.,
    // stemmer('considerations') // => 'consider'
    // stemmer('detestable') // => 'detest'
    // stemmer('vileness') // => 'vile'
    const queryWords = searchQuery
      .split(/[\s,.-]+/) // Split the search query on spaces or special characters like hyphens
      .filter(Boolean)
      .map((word) => stemmer(word.toLowerCase())); // Split query string and stem each word

    // Split text into words and non-words
    return text.split(/(\b[\w']+\b)/).map((part, index) => {
      const stemmedPart = stemmer(part.toLowerCase());
      if (queryWords.includes(stemmedPart)) {
        return (
          <span
            key={index}
            style={{
              textDecoration: `1px solid underline ${primaryColor}`,
              textUnderlineOffset: '2px'
            }}
          >
            {part}
          </span>
        );
      }
      return part;
    });
  };

  return <Typography variant={variant}>{getHighlightedText()}</Typography>;
};

export default HighlightedText;
